import { render, staticRenderFns } from "./Create-Customer.vue?vue&type=template&id=3f748b5f&scoped=true"
import script from "./Create-Customer.vue?vue&type=script&lang=js"
export * from "./Create-Customer.vue?vue&type=script&lang=js"
import style0 from "./Create-Customer.vue?vue&type=style&index=0&id=3f748b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f748b5f",
  null
  
)

export default component.exports